
/**
 * @license 
 * Copyright Google Inc. All Rights Reserved.
 * 
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const parse5 = require('parse5');

import {Injectable, Inject} from '@angular/core';
import {DOCUMENT, ɵgetDOM as getDOM} from '@angular/platform-browser';
/**
 * Representation of the current platform state.
 * 
 * \@experimental
 */
export class PlatformState {
/**
 * @param {?} _doc
 */
constructor(
private _doc: any) {}
/**
 * Renders the current state of the platform to string.
 * @return {?}
 */
renderToString(): string { return getDOM().getInnerHTML(this._doc); }
/**
 * Returns the current DOM state.
 * @return {?}
 */
getDocument(): any { return this._doc; }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [DOCUMENT, ] }, ]},
];
}

function PlatformState_tsickle_Closure_declarations() {
/** @type {?} */
PlatformState.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PlatformState.ctorParameters;
/** @type {?} */
PlatformState.prototype._doc;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
